import { onMounted, onUnmounted, type Ref } from 'vue';

/** IntersectionObserver 滚动显现；兼容异步插入的 .reveal 节点 */
export function useReveal(root: Ref<HTMLElement | null>) {
  let observer: IntersectionObserver | null = null;
  let mutationObserver: MutationObserver | null = null;

  const observeEl = (node: Element) => {
    if (!(node instanceof HTMLElement)) return;
    if (!node.classList.contains('reveal') || node.classList.contains('visible')) return;
    observer?.observe(node);
  };

  const observeTree = (node: Node) => {
    if (!(node instanceof Element)) return;
    observeEl(node);
    node.querySelectorAll?.('.reveal').forEach((el) => observeEl(el));
  };

  onMounted(() => {
    const el = root.value;
    if (!el) return;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer?.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    el.querySelectorAll('.reveal').forEach((t) => observeEl(t));

    mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => observeTree(node));
      });
    });
    mutationObserver.observe(el, { childList: true, subtree: true });
  });

  onUnmounted(() => {
    mutationObserver?.disconnect();
    mutationObserver = null;
    observer?.disconnect();
    observer = null;
  });
}
